var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07834 10.6934C0.78834 10.9959 0.78834 17.2384 5.07834 17.5409H6.83838",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12411 10.6933C2.18161 2.50743 14.5932 -0.76507 16.0141 7.83326C19.9832 8.33743 21.5874 13.6266 18.5808 16.2574C17.6641 17.0916 16.4816 17.5499 15.2441 17.5408H15.1616",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5834 15.6527C15.5834 16.331 15.4367 16.9727 15.1617 17.541C15.0884 17.706 15.0059 17.8618 14.9143 18.0085C14.1259 19.3377 12.6684 20.236 11.0001 20.236C9.33175 20.236 7.87423 19.3377 7.0859 18.0085C6.99423 17.8618 6.91177 17.706 6.83843 17.541C6.56343 16.9727 6.41675 16.331 6.41675 15.6527C6.41675 13.1227 8.47008 11.0693 11.0001 11.0693C13.5301 11.0693 15.5834 13.1227 15.5834 15.6527Z",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57007 15.6527L10.4776 16.5602L12.4301 14.7544",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFota);
export default __webpack_public_path__ + "static/media/fota.72ec4e348b4626140f8c940ed6cd7d82.svg";
export { ForwardRef as ReactComponent };